module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/CoupleViewingAlbum-1d799764e7924d0b0198f4c77661cf23.jpg";